<template>
    <div class="container production-line-index-container">
        <div class="card">
            <div class="card-header">
                <div class="row">
                    <div class="card-header-label col-2">
                        <span
                            class="mdi mdi-robot-industrial custom-icon"
                        ></span>
                        <span>Líneas de producción</span>
                    </div>
                    <div class="card-header-search-bar col-5">
                        <b-form-input
                            v-model="filter"
                            id="filter-input"
                            placeholder="Escriba aquí el texto a buscar"
                        >
                        </b-form-input>
                    </div>
                    <div class="card-header-pagination col-3">
                        <b-pagination
                            v-model="currentPage"
                            :total-rows="filteredList ? filteredList.length : 0"
                            :per-page="perPage"
                            aria-controls="productionLines-list"
                            style="margin: 0"
                            align="center"
                        >
                        </b-pagination>
                    </div>
                    <div class="card-header-action-buttons col-2">
                        <div>
                            <ButtonComponent
                                :buttonText="'Nuevo'"
                                :buttonColor="colors.GREEN_COLOR_BUTTON"
                                :buttonAction="gotToCreateProductionLine"
                            />
                            <ButtonComponent
                                :buttonText="'Refrescar'"
                                :buttonColor="colors.BLUE_COLOR_BUTTON"
                                :buttonAction="refreshProductionLines"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="isLoading" style="padding: 5ch 0">
                <SpeenComponent
                    :isAutomatic="true"
                    :ringWidth="14"
                    :spinnerSize="15"
                    :isverticalAligned="true"
                />
            </div>

            <div class="card-body" v-else>
                <b-table
                    id="productionLines-list"
                    :items="filteredList"
                    :fields="fields"
                    :per-page="perPage"
                    :current-page="currentPage"
                    small
                    striped
                    hover
                >
                    <template v-slot:cell(actions)="data">
                        <ButtonComponent
                            :buttonText="
                                canEditProductionLine ? 'Editar' : 'Ver'
                            "
                            :buttonColor="colors.GREEN_COLOR_BUTTON"
                            :buttonAction="
                                () => editProductionLine(data.item.id)
                            "
                        />
                        <ButtonComponent
                            :buttonText="'Borrar'"
                            :buttonColor="colors.RED_COLOR_BUTTON"
                            :buttonAction="
                                () => confirmDeleteProductionLine(data.item)
                            "
                        />
                    </template>
                </b-table>
            </div>
        </div>
        <transition name="slide-fade">
            <ActionConfirmModal
                v-if="showActionConfirmModal"
                :contentMessage="contentMessage"
                :closeModal="closeActionConfirmModal"
                :methodForProp="methodForProp"
            />
        </transition>
    </div>
</template>

<script>
import axios from "axios";
import { mapActions, mapGetters } from "vuex";
import { showCustomErrorSweetAlert, showCustomSuccessSweetAlert,} from "../../common/utils";
import SpeenComponent from "../../common/components/SpeenComponent.vue";
import PermissionsConsts from "../../common/permissions";
import ButtonComponent from "../../common/components/ButtonComponent.vue";
import Colors from "../../common/colors";
import { filterList } from "../../common/utils";
import ActionConfirmModal from "../../common/components/modals/ActionConfirmModal.vue";

export default {
    name: "ProductionLineIndex",
    components: {
        SpeenComponent,
        ButtonComponent,
        ActionConfirmModal,
    },
    data() {
        return {
            perPage: 10,
            currentPage: 1,
            productionLines: [],
            isLoading: true,
            colors: Colors,
            filter: '',
            showActionConfirmModal: false,
            contentMessage: '',
            methodForProp: null,
            fields: [
                {key: "code",       label: "Maquina ID",    sortable: true},
                {key: "descrip",    label: "Descripción",   sortable: true},
                {key: "actions",    label: "Ajustes",       sortable: false},
            ],
        };
    },
    methods: {
        ...mapActions("production_line", ["productionLineToEditIdChange"]),
        getProductionLinesData() {
            this.isLoading = true;
            axios
                .get("/api/production-line")
                .then((response) => {
                    this.productionLines = response.data;
                })
                .catch((error) => {
                    console.log(error);
                    showCustomErrorSweetAlert(error.response.data);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        refreshProductionLines() {
            this.getProductionLinesData();
        },
        editProductionLine(productionLineId) {
            window.location.href = `/production-line/${productionLineId}/edit`;
        },
        confirmDeleteProductionLine(prodLine) {
            this.contentMessage = `¿Está seguro de que desea eliminar la línea de producción ${prodLine.code}?`;
            this.methodForProp = () => {
                this.deleteProductionLine(prodLine.id);
            };
            this.openActionConfirmModal();
        },
        deleteProductionLine(productionLineId) {
            this.isLoading = true;
            axios.delete(`/api/production-line/admon/${productionLineId}`)
                .then(() => {
                    showCustomSuccessSweetAlert("Línea de producción eliminada correctamente");
                    this.refreshProductionLines();
                })
                .catch((error) => {
                    console.error(error);
                    showCustomErrorSweetAlert(error.response.data);
                })
                .finally(() => {
                    this.closeActionConfirmModal();
                });
        },
        gotToCreateProductionLine() {
            window.location.href = "/production-line/create";
        },
        openActionConfirmModal() {
            this.showActionConfirmModal = true;
        },
        closeActionConfirmModal() {
            this.showActionConfirmModal = false;
        },
    },
    computed:{
        ...mapGetters(['userPermissions','userHasPermission', 'isUserSuperadmin']),
        canEditProductionLine(){
            return this.isUserSuperadmin;
        },
        canDeleteProductionLine(){
            return this.isUserSuperadmin;
        },
        canCreateProductionLine(){
            return this.isUserSuperadmin;
        },
        showActionsColumn() {
            return this.canEditProductionLine || this.canDeleteProductionLine;
        },
        filteredList: function () {
            return filterList(this.productionLines, this.fields, this.filter);
        },
    },
    mounted() {
        this.getProductionLinesData();
    },
};
</script>

<style lang="scss">
.production-line-index-container {
    #productionLines-list {
        [aria-colindex="1"] {width: 38%;}
        [aria-colindex="2"] {width: 50%;}
        [aria-colindex="3"] {width: 12%;}
    }
}
</style>
